// ============================================================
// Platform Control · General — workspace identity, default
// region, billing email. Read-only until the workspace settings
// API exists; the view exposes the fields that *will* be edited
// so the eventual write surface drops in cleanly.
// ============================================================

import ViewShell, { Card, Row, Section } from './_ViewShell'
import EmptyState from '../../../components/EmptyState'

export default function GeneralView() {
  return (
    <ViewShell
      kicker="PLATFORM CONTROL · GENERAL"
      title="General"
      description="Workspace identity and defaults that apply across every project."
    >
      <Section label="WORKSPACE">
        <Card>
          <Row label="Workspace name" value="Square Code" hint="display name" />
          <Row label="Slug" value="square-code" hint="immutable" />
          <Row label="Default region" value="—" hint="not yet configured" />
          <Row label="Time zone" value="UTC" hint="default" />
        </Card>
      </Section>

      <Section label="OWNERSHIP">
        <EmptyState
          title="Ownership transfer"
          body="Ownership transfer will be available in a future release."
        />
      </Section>
    </ViewShell>
  )
}
